import { render, staticRenderFns } from "./Amenity.vue?vue&type=template&id=8aa32128&scoped=true&"
import script from "./Amenity.vue?vue&type=script&lang=js&"
export * from "./Amenity.vue?vue&type=script&lang=js&"
import style0 from "./Amenity.vue?vue&type=style&index=0&id=8aa32128&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa32128",
  null
  
)

export default component.exports